import { render, staticRenderFns } from "./fund-search-share.vue?vue&type=template&id=267e96e5&scoped=true&lang=pug"
import script from "./fund-search-share.vue?vue&type=script&setup=true&lang=js"
export * from "./fund-search-share.vue?vue&type=script&setup=true&lang=js"
import style0 from "./fund-search-share.vue?vue&type=style&index=0&id=267e96e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e96e5",
  null
  
)

export default component.exports